import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import { isSaleProductId } from '../../Common/_hooks/useIsSaleProduct';
import type { ProductCatalogCollection } from './ProductCatalogCollection';

const onSaleCollection: ProductCatalogCollection = {
  description: t => t('Starting NOW until June 9th, enjoy 20% off the drop ship price on all custom all-over print clothing.'),
  isActive: context => context.isSale,
  matchesProduct: product => isSaleProductId(product.get('id_product')),
  navIcon: LocalOfferRoundedIcon,
  navTone: 'sale',
  slug: 'on-sale',
  title: t => t('ON SALE'),
};

export default onSaleCollection;
